import { BsStarFill } from "react-icons/bs";
import { HiArrowRight } from "react-icons/hi";
import Text from "./Text";
import IconText from "./IconText";
import Divider from "./Divider";
import React, { useState } from "react";

const CustomerReviews = () => {
  const [hovered, setHovered] = useState(false);
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <div>
      <div className="customer-review text-[#828282] px-4">
        <div className="heading">
          <div className="title">
            <Text classes={"text-[20px] font-medium text-black"}>
              Customer Reviews
            </Text>
          </div>
        </div>
        <div className="whole-review flex mt-2 mb-4">
          <div className="stars text-[#FFC107] flex">
            {Array(5)
              .fill(true)
              .map((star, index) => (
                <IconText iconInfo={{ Icon: BsStarFill }} key={index} />
              ))}
          </div>
          <div className="ml-4">
            <Text classes={"text-sm"}>Customer Reviews</Text>
          </div>
        </div>
        <ul className="reviews-list py-6 flex flex-wrap -ml-4">
          {Array(5)
            .fill(true)
            .map((review, index) => {
              return (
                <li className="xs:w-full sm:w-1/2 md:w-1/3 p-4" key={index}>
                  <div>
                    <div className="heading flex flex-wrap">
                      <div className="reviewer pr-2">
                        <Text classes={"text-base text-black font-medium"}>
                          Abdulateef
                        </Text>
                      </div>
                      <div className="rate text-[#FFC107] flex">
                        {Array(5)
                          .fill(true)
                          .map((star, index) => (
                            <IconText
                              iconInfo={{ Icon: BsStarFill }}
                              key={index}
                            />
                          ))}
                      </div>
                    </div>
                    <div className="date text-black text-[13px]">
                      <Text>Aug 20, 2021</Text>
                    </div>
                    <div className="review-desc mt-2 text-sm flex">
                      <Text classes={"pt-2"}>
                        Lorem 2 ipsum dolor sit amet consectetur adipisicing
                        elit. Vero, repudiandae. Expedita exercitationem
                      </Text>
                    </div>
                  </div>
                </li>
              );
            })}

          {/* <li>
            <div>
              <div className="heading flex">
                <div className="reviewer mr-4">
                  <Text classes={"text-base text-black font-medium"}>
                    Abdulateef
                  </Text>
                </div>
                <div className="rate text-[#FFC107] flex">
                  {Array(5)
                    .fill(true)
                    .map((star, index) => (
                      <IconText iconInfo={{ Icon: BsStarFill }} key={index} />
                    ))}
                </div>
              </div>
              <div className="date text-black text-[13px]">
                <Text>Aug 20, 2021</Text>
              </div>
              <div className="review-desc mt-2 text-sm flex">
                <Text classes={"pt-2 w-9/12"}>
                  Lorem 2 ipsum dolor sit amet consectetur adipisicing elit.
                  Vero, repudiandae. Expedita exercitationem
                </Text>
              </div>
            </div>
          </li> */}
        </ul>
        <Divider />
        <div
          className="show-all my-4 text-[15px] font-semibold text-[#e66553] cursor-pointer"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <IconText
            textInfo={{ text: "Load More", clasees: "coapitalize" }}
            iconInfo={{
              Icon: HiArrowRight,
              classes: `w-4 h-4 transition-all duration-300 ${
                hovered ? "translate-x-1" : "-translate-x-1"
              }`,
              id: "arrow",
            }}
            gap={"w-4"}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerReviews;
